(() => {
  const root = document.querySelector('[data-product-page]');
  if (!root) return;

  const mainImage = root.querySelector('.il-product-gallery__main-image');
  const thumbnails = Array.from(root.querySelectorAll('[data-product-thumb]'));
  let activeImageIndex = Math.max(0, thumbnails.findIndex((item) => item.classList.contains('is-active')));
  const showImage = (index) => {
      if (!mainImage || !thumbnails.length) return;
      activeImageIndex = (index + thumbnails.length) % thumbnails.length;
      const button = thumbnails[activeImageIndex];
      mainImage.removeAttribute('srcset');
      mainImage.removeAttribute('sizes');
      if (!mainImage) return;
      mainImage.src = button.dataset.imageSrc;
      mainImage.alt = button.dataset.imageAlt || '';
      thumbnails.forEach((item) => item.classList.toggle('is-active', item === button));
      button.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
  };
  thumbnails.forEach((button, index) => {
    button.addEventListener('click', () => showImage(index));
  });
  root.querySelector('[data-gallery-previous]')?.addEventListener('click', () => showImage(activeImageIndex - 1));
  root.querySelector('[data-gallery-next]')?.addEventListener('click', () => showImage(activeImageIndex + 1));

  root.querySelectorAll('[data-quantity]').forEach((quantity) => {
    const input = quantity.querySelector('input');
    quantity.querySelectorAll('[data-quantity-change]').forEach((button) => {
      button.addEventListener('click', () => {
        const next = Math.max(1, Number(input.value || 1) + Number(button.dataset.quantityChange));
        input.value = String(next);
      });
    });
  });

  const variantsNode = root.querySelector('[data-product-variants]');
  const selector = root.querySelector('select[data-product-variant]');
  if (variantsNode && selector) {
    const variants = JSON.parse(variantsNode.textContent || '[]');
    const updateVariant = (variant) => {
      if (!variant) return;
      const currency = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: window.Shopify?.currency?.active || 'GBP' });
      root.querySelectorAll('[data-product-sku]').forEach((item) => { item.textContent = variant.sku || 'Not recorded'; });
      root.querySelectorAll('[data-product-option]').forEach((item) => { item.textContent = variant.public_title || variant.title; });
      root.querySelectorAll('[data-product-price]').forEach((price) => { price.textContent = currency.format(variant.price / 100); });
      root.querySelectorAll('[data-product-stock]').forEach((stock) => {
        stock.innerHTML = `<span aria-hidden="true"></span>${variant.available ? 'In stock' : 'Unavailable'}`;
        stock.classList.toggle('il-stock--unavailable', !variant.available);
      });
      root.querySelectorAll('[data-product-stock-text]').forEach((item) => { item.textContent = variant.available ? 'In stock' : 'Unavailable'; });
      root.querySelectorAll('[data-product-add]').forEach((add) => { add.disabled = !variant.available; add.textContent = variant.available ? 'Add to Basket' : 'Unavailable'; });
      root.querySelectorAll('[data-modal-variant]').forEach((input) => { input.value = String(variant.id); });

      const isNonSterile = /non[- ]sterile/i.test(variant.public_title || variant.title || '');
      root.querySelectorAll('[data-product-spec-row]').forEach((row) => {
        const label = (row.dataset.productSpecLabel || '').toLowerCase();
        const conflictsWithVariant = label === 'sterility' || label === 'sterilization' || label === 'sterility assurance level';
        row.hidden = isNonSterile && conflictsWithVariant;
      });
      root.querySelectorAll('[data-variant-sterility]').forEach((row) => {
        row.hidden = !isNonSterile;
      });
    };

    selector.addEventListener('change', () => {
      updateVariant(variants.find((item) => String(item.id) === selector.value));
    });
    updateVariant(variants.find((item) => String(item.id) === selector.value));
  }

  const dialog = root.querySelector('[data-specifications-dialog]');
  root.querySelectorAll('[data-specifications-open]').forEach((button) => button.addEventListener('click', () => dialog?.showModal()));
  root.querySelectorAll('[data-specifications-close]').forEach((button) => button.addEventListener('click', () => dialog?.close()));
  dialog?.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
})();
